/**
 * @license
 * Copyright Alibaba.com All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */

export default {
  today: 'Danes',
  now: 'Trenutno',
  backToToday: 'Nazaj na danes',
  ok: 'V redu',
  clear: 'PoÄisti',
  month: 'Mesec',
  year: 'Leto',
  timeSelect: 'Izberite Äas',
  dateSelect: 'Izberite datum',
  monthSelect: 'Izberite mesec',
  yearSelect: 'Izberite leto',
  decadeSelect: 'Izberite desetletje',
  yearFormat: 'YYYY',
  dateFormat: 'DD.MM.YYYY',
  dayFormat: 'D',
  dateTimeFormat: 'DD.MM.YYYY HH:mm:ss',
  monthBeforeYear: true,
  previousMonth: 'PrejÅ¡nji mesec (PageUp)',
  nextMonth: 'Naslednji mesec (PageDown)',
  previousYear: 'PrejÅ¡nje leto (Control + left)',
  nextYear: 'Naslednje leto (Control + right)',
  previousDecade: 'PrejÅ¡nje desetletje',
  nextDecade: 'Naslednje desetletje',
  previousCentury: 'PrejÅ¡nje stoletje',
  nextCentury: 'Naslednje stoletje'
};
